import { merge } from 'lodash-es'
import { i18nInstance } from '~i18n'


export const SUPPORTED_LOCALES = ['en'] as const
export const DEFAULT_LOCALE = SUPPORTED_LOCALES[0]

export async function loadLanguage (
  locale: typeof SUPPORTED_LOCALES[number],
  localeOverride?: string,
): Promise<void> {
  // load locale messages with dynamic import
  const result = await import(`../i18n/${locale}.json`)
  const defaultMessages = result.default

  let override = localeOverride && JSON.parse(localeOverride)

  if (override && typeof override !== 'object') {
    override = {}
    console.error(`Override for lang ${locale} is not a valid JSON. Falling back to default resources.`)
  }

  const messages = merge({}, defaultMessages, override)
  i18nInstance.global.locale.value = locale
  i18nInstance.global.setLocaleMessage(locale, messages)

  // Fallback document title for pages that don't have a dynamic title
  document.title = i18nInstance.global.t('platform.title')

  let metaDescription = document.querySelector('meta[name="description"]')
  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.setAttribute('name', 'description')
    document.head.appendChild(metaDescription)
  }
  metaDescription.setAttribute('content', i18nInstance.global.t('platform.description'))
}
